// extracted by mini-css-extract-plugin
module.exports = {"go-back-navi":"style_go-back-navi__NJuUk","go-back-navi-icon":"style_go-back-navi-icon__iT7PK","go-back-navi-text":"style_go-back-navi-text__qdD8V"};